/**
 * UserMgtAPI.V1
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: V1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
    HttpClient, HttpEvent, HttpHeaders,
    HttpResponse
} from '@angular/common/http';

import { Observable } from 'rxjs';

import { UserInfo } from '../model/userInfo';

import { Configuration } from '../configuration';
import { BASE_PATH } from '../../../../app.GlobalSettings';

@Injectable()
export class UserManagementService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     *
     *
     * @param userInfo
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createNewUser(userInfo?: UserInfo, observe?: 'body', reportProgress?: boolean): Observable<UserInfo>;
    public createNewUser(userInfo?: UserInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserInfo>>;
    public createNewUser(userInfo?: UserInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserInfo>>;
    public createNewUser(userInfo?: UserInfo, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'text/plain',
            'application/octet-stream',
            'application/csp-report',
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json',
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<UserInfo>(`${this.basePath}/api/usermgt`,
            userInfo,
            {
                withCredentials: this.configuration.withCredentials,
                headers,
                observe,
                reportProgress,
            },
        );
    }

    /**
     *
     *
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCustomerUsers(observe?: 'body', reportProgress?: boolean): Observable<UserInfo[]>;
    public getCustomerUsers(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserInfo[]>>;
    public getCustomerUsers(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserInfo[]>>;
    public getCustomerUsers(observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<UserInfo[]>(`${this.basePath}/api/usermgt/GetCustomerUsers`,
            {
                withCredentials: this.configuration.withCredentials,
                headers,
                observe,
                reportProgress,
            },
        );
    }

    /**
     *
     *
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getProductUsers(observe?: 'body', reportProgress?: boolean): Observable<UserInfo[]>;
    public getProductUsers(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserInfo[]>>;
    public getProductUsers(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserInfo[]>>;
    public getProductUsers(observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<UserInfo[]>(`${this.basePath}/api/usermgt/GetProductUsers`,
            {
                withCredentials: this.configuration.withCredentials,
                headers,
                observe,
                reportProgress,
            },
        );
    }

    /**
     *
     *
     * @param userInfo
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resetPassword(userInfo?: UserInfo, observe?: 'body', reportProgress?: boolean): Observable<UserInfo>;
    public resetPassword(userInfo?: UserInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserInfo>>;
    public resetPassword(userInfo?: UserInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserInfo>>;
    public resetPassword(userInfo?: UserInfo, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'text/plain',
            'application/octet-stream',
            'application/csp-report',
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json',
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<UserInfo>(`${this.basePath}/api/usermgt/ResetPassword`,
            userInfo,
            {
                withCredentials: this.configuration.withCredentials,
                headers,
                observe,
                reportProgress,
            },
        );
    }

    /**
     *
     *
     * @param userInfo
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateUser(userInfo?: UserInfo, observe?: 'body', reportProgress?: boolean): Observable<UserInfo>;
    public updateUser(userInfo?: UserInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserInfo>>;
    public updateUser(userInfo?: UserInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserInfo>>;
    public updateUser(userInfo?: UserInfo, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'text/plain',
            'application/octet-stream',
            'application/csp-report',
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json',
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<UserInfo>(`${this.basePath}/api/usermgt`,
            userInfo,
            {
                withCredentials: this.configuration.withCredentials,
                headers,
                observe,
                reportProgress,
            },
        );
    }

}
